import type {ResponseHeaders} from '@yandex-delivery/core/utils/network'
import {blobToFile} from '@yandex-delivery/utils/files'

type DownloadFileResponse = {
  body: Blob
  headers: ResponseHeaders
}

export function downloadFile(fallbackFilename: string) {
  return function ({body, headers}: DownloadFileResponse) {
    // Забираем имя файла из хедера
    blobToFile(headers['content-disposition'].match(/filename="([^"]+)"/)?.[1] || fallbackFilename)(body)
  }
}
